import useNavCollapse from "../../hooks/useNavCollapose.hook";
import Bar2Icon from "../../icons/bar2.icon";

export default function DesktopNavExpandBtn() {
  const [collapse, setNavCollapse] = useNavCollapse();

  const css = "hidden cursor-pointer " + (collapse ? "md:block " : "");

  return (
    <button className={css} onClick={() => setNavCollapse(false)}>
      <Bar2Icon />
    </button>
  );
}
